// extracted by mini-css-extract-plugin
export default {"codeBox":"InstallTrackingCode_codeBox__SHZTo","copyIcon":"InstallTrackingCode_copyIcon__ghRa5"};